/* eslint-disable no-console */
import { Widget } from "blue-widgets";

class FilterBlock extends Widget {
  constructor(el) {
    super(el);
    this.formSubmitHandler = this.formSubmitHandler.bind(this);
    this.form = this.el.querySelector("[data-filter-form]");
    this.formSubmit = this.el.querySelector("[data-filter-submit]");
    this.resultsArea = this.el.querySelector("[data-filter-results]");
    this.pagination = this.el.querySelector("[data-filter-pagination]");
    this.noResults = this.el.querySelector("[data-filter-noresults]");
    this.selectInput = this.el.querySelector("[data-select-input]");
    this.onlyCategory = JSON.parse(this.el.getAttribute("data-only-category"));
    this.currentPage = 1;
    this.lastCategory = null;
    this.currentCategory = null;
    this.fetchItems = this.fetchItems.bind(this);
    this.init();
  }

  init() {
    if (this.onlyCategory) {
      this.selectInput.addEventListener("change", (e) => {
        this.selectHandler(e);
      });
    } else {
      if (this.formSubmit) {
        this.formSubmit.addEventListener("click", (e) => {
          this.formSubmitHandler(e, 0);
        });
      }
    }
    this.pagination.addEventListener("pagination-value-changed", (e) => {
      this.formSubmitHandler(e, e?.detail?.value || 0);
    });
    this.setPaginationNum();
  }

  async fetchItems() {
    if (!this.options.filterUrl || !this.options.pageKey) {
      return;
    }

    const params = new URLSearchParams({
      pageKey: this.options.pageKey,
      pageSize: this.options.pageSize || 12,
      page: this.currentPage || 1,
      ...(this.onlyCategory ? {} : { qualification: this.body.course || "" }),
      ...(this.onlyCategory ? {} : { campus: this.body.location || "" }),
      ...(this.onlyCategory ? { category: this.currentCategory || "" } : {})
    });

    try {
      const res = await fetch(
        this.options.filterUrl + "?" + params.toString(),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (res.status === 200) {
        const jsonContent = await res.json();

        const { html, page, pageSize, totalItems } = jsonContent;
        this.paginationHandler(page, pageSize, totalItems);

        this.resultsArea.innerHTML = html;
      }

      if (res.status === 500) {
        this.resultsArea.innerHTML = "";
      }
    } catch (error) {
      console.error(error);
    }
  }

  paginationHandler(page, pageSize, totalItems) {
    const pages = Math.ceil(totalItems / pageSize);
    this.pagination.setAttribute("data-pages", pages);
    this.pagination.setAttribute("data-current-page", page);
  }

  getFormValuesHandler() {
    const body = {
      qualification: "",
      campus: ""
    };
    if (this.form) {
      const filterSelects = Array.from(this.form.querySelectorAll("select"));

      filterSelects.forEach((select) => {
        const name = select.getAttribute("name");
        body[name] = select.value;
      });
    }

    return body;
  }

  formSubmitHandler(e, page) {
    e.preventDefault();
    this.body = this.getFormValuesHandler();
    this.currentPage = page || 1;
    this.fetchItems();
  }

  selectHandler(e) {
    this.currentCategory = this.selectInput.value;
    if (this.selectInput.value === this.lastCategory) return;
    this.formSubmitHandler(e, 0);
    this.lastCategory = this.currentCategory;
  }

  setPaginationNum() {
    this.resultsWrapper = this.el.querySelector("[data-items-count]");
    this.items = JSON.parse(
      this.resultsWrapper.getAttribute("data-items-count")
    );
    const pages = Math.ceil(this.items / this.options.pageSize);
    if (pages) this.pagination.setAttribute("data-pages", pages);
  }

  beforeRemove() {
    if (this.onlyCategory) {
      this.selectInput.removeEventListener("change", this.selectHandler);
    } else {
      this.formSubmit.removeEventListener("click", this.formSubmitHandler);
    }
    this.pagination.removeEventListener(
      "pagination-value-changed",
      this.formSubmitHandler
    );
  }
}

export default FilterBlock;
